<script lang="ts">
import {defineComponent} from 'vue'
import CustomDatePicker from "@/view/content/custom-date-picker.vue";

export default defineComponent({
  name: "ManagementAdvanced",
  components: {CustomDatePicker},
  data() {
    return {
      dateTime: null,
      listModel: 'default',
      listItems: [
        {text: 'اولویت مبلغ ( پرکردن سقف ها )', value: 'AmountPriority'},
        {text: 'ترتیبی ( نوبت دهی )', value: 'inOrder'}
      ],
    }
  }
})

</script>

<template>
  <div class="row">

    <div class="col-12">
      <v-text-field
          type="number"
          append-icon="mdi-av-timer"
          class="mt-0 pt-0 contentinfo"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          label="زمان انتظار ( دقیقه )"
          outlined
      />
    </div>

    <div class="col-12">
      <v-select v-model="listModel" :items="listItems" :menu-props="{offsetY: true}" dense hide-details
                label="الگوریتم توزیع" outlined/>
    </div>




  </div>

</template>

<style scoped>

</style>